import type { HistoryMessageModel } from '@mindverse/accessor-open';

import type { ChatVoiceInfo, Config, ContactListResponse, MindConfig } from '@/types/chat';
import type { CommonResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';

export function fetchContactInfo(params: { pageNo: number; pageSize: number; keyword?: string }) {
  return Request<CommonResponse<ContactListResponse>>({
    url: '/rest/os/contacts/search',
    method: 'get',
    params
  });
}

// 设置声音状态：静音还是播放
export function setMuteStatus(data: { mindId: string; status: 'mute' | 'unmute' }) {
  return Request<CommonResponse<string>>({
    url: '/rest/os/mind/mute/set/status',
    method: 'post',
    data
  });
}

// 获取声音状态
export function getMuteStatus(params: { mindId: string }) {
  return Request<CommonResponse<string>>({
    url: '/rest/os/mind/mute/get/status',
    method: 'get',
    params
  });
}

// 获取Mind配置信息[avatar或voice]
export function getMindConfig(params: { mindId: string; type: 'AVATAR' | 'VOICE' }) {
  return Request<CommonResponse<MindConfig>>({
    url: '/rest/os/mind/config/get/mind/config',
    method: 'get',
    params
  });
}

// 保存Mind配置信息[avatar或voice]
export function saveMindConfig(data: { mindId: string; type: 'AVATAR' | 'VOICE'; config: Config }) {
  return Request<CommonResponse<MindConfig>>({
    url: '/rest/os/mind/config/save/mind/config',
    method: 'post',
    data
  });
}

export function getSuggestionBySessionId(sessionId: string) {
  return Request<CommonResponse<string[]>>({
    url: '/rest/os/chat/get/suggestion/by/context',
    method: 'get',
    params: { sessionId }
  });
}

export function getChatMessages(params: { sessionId: string; userId: string }) {
  return Request<CommonResponse<HistoryMessageModel>>({
    url: 'rest/general/message/query_v2',
    method: 'get',
    params
  });
}

export function getChatVoiceList() {
  return Request<CommonResponse<ChatVoiceInfo[]>>({
    url: '/rest/os/realtime/voices',
    method: 'get'
  });
}

export function setChatVoice(data: { voice: string }) {
  return Request<CommonResponse<null>>({
    url: '/rest/os/realtime/voice/set',
    method: 'post',
    data
  });
}

export function recallMessage(data: {
  messageId: string;
  sessionId: string;
  sender: string;
  sendUserId: string;
  action: 'revoke' | 'shield';
}) {
  return Request<CommonResponse<null>>({
    url: '/rest/general/message/action',
    method: 'post',
    data
  });
}
